import React from 'react';
import './Updates.css';

const updatesData = {
  linkedInPosts: [
    {
      author: "Dr. Emily Chen",
      title: "AI-Powered Speech Recognition in Healthcare",
      time: "1 hr ago",
      description: "Excited to share how Genix.ai is revolutionizing medical documentation. The accuracy and ease of use are incredible...",
      image: "/images/genix-logo.png",
      ctaText: "Read more on LinkedIn →"
    },
    {
      author: "Dr. Michael Roberts",
      title: "Future of Medical Documentation",
      time: "3 hrs ago",
      description: "Just completed my first week using Genix.ai. The ambient voice recognition has transformed my patient interactions...",
      image: "/images/genix-logo.png",
      ctaText: "Read more on LinkedIn →"
    }
  ],
  infoCards: [
    {
      title: "Latest Updates",
      description: "Stay informed about the latest developments in AI-powered healthcare documentation.",
      ctaText: "Learn more →"
    },
    {
      title: "Join Our Community",
      description: "Connect with healthcare professionals using Genix.ai and share your experiences.",
      ctaText: "Learn more →"
    }
  ],
  featureCard: {
    image: "/images/update1.png",
    title: "Improving patient workflows with speech to text →",
    altText: "Doctor using Genix pendant for voice recording"
  }
};

const Updates = () => {
  return (
    <section className="updates-section">
      <div className="updates-container">
        {/* Left Column */}
        <div className="updates-column">
          {/* LinkedIn Post Card */}
          <div className="card linkedin-card">
            <div className="card-header">
              <img src="/images/blogimg2.png  " alt="Genix.ai" className="company-logo" />
              <div className="post-meta">
                <h4>Genix Healthcare</h4>
                <span className="time">{updatesData.linkedInPosts[0].time}</span>
              </div>
              <img src="/images/doctor1.png" alt="LinkedIn" className="platform-icon" />
            </div>
            <p className="post-content">{updatesData.linkedInPosts[0].description}</p>
            <a href="https://www.linkedin.com/company/genixai-healthcare/" className="cta-link">{updatesData.linkedInPosts[0].ctaText}</a>
          </div>

          {/* Info Card */}
          <div className="card info-card">
            <h3>{updatesData.infoCards[0].title}</h3>
            <p>{updatesData.infoCards[0].description}</p>
            <a href="#" className="cta-link">{updatesData.infoCards[0].ctaText}</a>
          </div>
        </div>

        {/* Center Column - Feature Image */}
        <div className="feature-column">
          <div className="feature-card">
            <img 
              src={updatesData.featureCard.image} 
              alt={updatesData.featureCard.altText}
              className="feature-image" 
            />
            <div className="feature-overlay">
              <h3>{updatesData.featureCard.title}</h3>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="updates-column">
          {/* Info Card */}
          <div className="card info-card">
            <h3>{updatesData.infoCards[1].title}</h3>
            <p>{updatesData.infoCards[1].description}</p>
            <a href="#" className="cta-link">{updatesData.infoCards[1].ctaText}</a>
          </div>

          {/* LinkedIn Post Card */}
          <div className="card linkedin-card">
            <div className="card-header">
              <img src="/images/blogimg2.png" alt="Genix.ai" className="company-logo" />
              <div className="post-meta">
                <h4>Genix Healthcare</h4>
                <span className="time">{updatesData.linkedInPosts[1].time}</span>
              </div>
              <img src="/images/doctor1.png" alt="LinkedIn" className="platform-icon" />
            </div>
            <p className="post-content">{updatesData.linkedInPosts[1].description}</p>
            <a href="https://www.linkedin.com/company/genixai-healthcare/" className="cta-link">{updatesData.linkedInPosts[1].ctaText}</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Updates; 